import { z } from 'zod';

import { applicantMetadata, ownershipDetails } from '../shared';
import { ApplicationStep } from '../types';
import { baseApplicationStep } from './baseApplication';

export const updateOwnershipDetailsSchema = z
  .object({
    step: z.literal(ApplicationStep.OwnershipDetails),
    enterprise: ownershipDetails,
    applicant: applicantMetadata.pick({ type: true }),
  })
  .and(baseApplicationStep);
